module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-pic02-bf4a75f1e895295d79cceee604038d4f.png";